// extracted by mini-css-extract-plugin
export default {"centerHERE":"suspense_centerHERE__JWk1v","lds_roller":"suspense_lds_roller__bftHr","lds_spinner":"suspense_lds_spinner__OF5HH"};